import mapValues from 'lodash-es/mapValues';

import {
  type CanvasElementType,
  type MultipleColumnsPath,
  type PropsOf,
} from '@blaze-runtime/engine-domain';
import {
  type PropertiesConfigInputListCustomFieldModel,
  type PropertiesConfigInputTableColumnModel,
} from '@blaze-shared/elements-domain';
import { getValueByPath } from '@blaze-shared/workflow-domain';

// Reusable union for the column value type.
type ColumnsValue =
  | PropertiesConfigInputTableColumnModel[]
  | PropertiesConfigInputListCustomFieldModel[];

export function getPropsColumns(
  props: PropsOf<CanvasElementType>,
  columnsPath: string | MultipleColumnsPath<string> | undefined,
): Record<string, ColumnsValue | undefined | null> {
  // Single path (or undefined): return under the empty-key, matching previous behavior.
  if (typeof columnsPath === 'string' || columnsPath === undefined) {
    return { '': getValueByPath<ColumnsValue>(props, columnsPath) };
  }

  return mapValues(columnsPath, (path) => getValueByPath<ColumnsValue>(props, path));
}
